<ng-container *ngIf="!disableStreaming">
  <div id="ush-at-home-wrapper" class="ush-at-home-wrapper">
    <div
      *ngIf="countries.length > 1 && !countryBasedDropdownEnabled"
      id="countrySelectWrapper"
      class="p-field p-grid p-col-12 attached"
    >
      <label for="input-countries" class="bold"
        ><span>{{ 'public.filters.country.label' | translate: { placeholder: 'Country' } }}</span></label
      >
      <div class="p-col field-box attached">
        <feature-streaming-country-selector
          [dropdownIcon]="dropdownIcon"
          (countryChanged)="onCountryChanged($event)"
        ></feature-streaming-country-selector>

        <p-button
          id="myCountryBtn"
          class="fit-width"
          type="button"
          [label]="'public.filters.country.myCountry' | translate: { placeholder: 'My country' }"
          (click)="setMyCountry()"
        ></p-button>
      </div>
    </div>

    <div *ngIf="!country" class="tab-msg ush-error-msg text">
      {{ 'public.commons.noCountry' | translate: { placeholder: 'There is no country selected' } }}
    </div>

    <!-- uplayer watch now button -->
    <ush-uplay-button
      *ngIf="uplayerEnabled"
      [movie]="movie()"
      [watchNowCustomString]="'movie.watchNow.streamingWidget'"
      [playNowCustomString]="'movie.playNow.streamingWidget'"
      [availableToWatchCustomString]="'movie.availableToWatch.streamingWidget'"
      [preOrderCustomString]="'movie.preOrder.streamingWidget'"
      (uplayLoaded)="onUplayButtonDisplayed($event)"
    >
    </ush-uplay-button>
    <!-- end uplayer watch now button -->

    <!-- also available message -->
    <div class="streaming-also-available subtitle" *ngIf="uplayerBtnVisible && streams?.length > 0">
      {{ 'movie.streaming.alsoAvailable' | translate: { placeholder: 'Also available to watch at' } }}
    </div>
    <!-- end also available message -->

    <ng-container *ngIf="country">
      <ng-container *ngIf="streams && !loadingStreams; else skeleton">
        <div
          *ngIf="streams.length === 0 && !uplayerBtnVisible"
          class="tab-msg ush-error-msg text"
          [innerHTML]="errorMsg | safe: 'html'"
        ></div>
        <ul *ngIf="streams.length > 0" class="streaming-list" role="list">
          <li *ngFor="let ms of streams" [class]="'streaming-platform-' + ms.streamingPlatform.slug">
            <a
              [href]="ms.url"
              (click)="onStreamingRedirect(ms)"
              target="_blank"
              [attr.aria-label]="ms.streamingPlatform.name"
              role="button"
              tabindex="0"
            >
              @if (ms.streamingPlatform.imageUrl && !ms.streamingPlatform.imgError) {
                <img
                  class="streaming-logo"
                  (error)="onStreamingPlatformImgError(ms.streamingPlatform)"
                  width="130"
                  height="130"
                  [ngSrc]="ms.streamingPlatform.imageUrl"
                  [alt]="ms?.streamingPlatform?.name + ' logo'"
                />
              } @else {
                <ush-streaming-logo-fallback [streamingPlatform]="ms.streamingPlatform" />
              }
            </a>
          </li>
        </ul>
      </ng-container>
    </ng-container>
  </div>
  @if (showUsheruLogo) {
    <ush-usheru-logo />
  }
</ng-container>
<ng-template #skeleton>
  <ul class="streaming-list" role="list">
    <li *ngFor="let movie of [].constructor(6)">
      <ui-movie-card-placeholder></ui-movie-card-placeholder>
    </li>
  </ul>
</ng-template>
